export const workingHours = {
  start: '6:00',
  end: '22:00',
  interval: 30, // default interval in minutes
};
